/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Icons
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { healthicons } from '../plugins/healthicons'

const theme = {
    defaultTheme: 'light',
    themes: {
        light: {
            colors: {
                primary: '#FFCF04',
                secondary: '#E8E7ED',
                tertiary: '#FFEFD1',
                subtitle: '#615867',
                error: '#E75F5F',
                success: '#AFE2D9',
                warning: '#FDD06D',
                info: '#7197F0',
                surface: '#FFFFFF',
                background: '#FFFFFF',
                altBackground: '#332E45',
                iconBackground: '#D0A900',
                'on-primary': '#000',
                'on-surface': '#000',
                'on-background': '#000',
                dashboardBackground: '#ffffff',
            },
        },
        dark: {
            colors: {
                primary: '#348ceb',
                secondary: '#E8E7ED',
                tertiary: '#FFEFD1',
                error: '#ff5252',
                success: '#11ba8d',
                background: '#222222',
                dashboardBackground: '#303030',
            },
        },
    },
}

const defaults = {
    VBtn: {
        flat: true,
        variant: 'elevated',
    },
    VTextField: {
        variant: 'outlined',
        density: 'comfortable',
        color: '#000',
    },
    VTextarea: {
        variant: 'outlined',
        density: 'comfortable',
        color: '#000',
    },
    VCheckbox: {
        density: 'comfortable',
        color: 'primary',
    },
    VSelect: {
        variant: 'outlined',
        density: 'comfortable',
        color: '#000',
    },
    VPagination: {
        variant: 'flat',
        density: 'comfortable',
        activeColor: 'primary',
    },
    VCard: {
        elevation: 0, // removes box-shadow
        variant: 'flat', // ensures no elevation hover states
    },
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    components,
    directives,
    theme,
    defaults,
    // Vuetify maps its 'en' locale to 'en-US' for dates, which reads and shows
    // MM/DD/YYYY. Use en-GB so any Vuetify date component works in DD/MM/YYYY.
    date: {
        locale: { en: 'en-GB' },
    },
    icons: {
        defaultSet: 'mdi',
        sets: {
            mdi,
            healthicons,
        },
    },
})
